export function getLanguageButExcludeGerman(language: string): string {
  if (language === 'de') {
    return 'en';
  }
  return language;
}
